module.exports = __webpack_public_path__ + "img/facebook-event.png";